import FormControl from "@material-ui/core/FormControl";
import styled from "styled-components";

export const Root = styled(FormControl)`
  ${({ theme }) => `
    margin-top: ${theme.spacing(1.5)}px;
  `}
`;
